export enum OrdersAlerts {
    CREATED_NEW_ORDER = "orders.alerts.createdNewOrder",
    EDITED_ORDER = "orders.alerts.editedOrder",
    FILL_ALL_FILEDS = "orders.alerts.fillAllFields"
}